export default __webpack_public_path__ + "static/media/play.40ca9611.png";